import axios from "axios";
import { useState } from "react";
import { getHost } from "../helpers/getHost";
import { encodeImageAsURL, getRemainingLimit } from "../helpers/stringHelpers";
import { getBase64Size } from "../helpers/getBase64Size";

const useWritePost = (user, authorName, refetch) => {
  const [message, setMessage] = useState("");
  const [show, setShow] = useState(false);
  const [converted, setConverted] = useState("");

  const fileSize = getBase64Size(converted);
  const characterLimit = getRemainingLimit(message, 255);
  const canSubmit = fileSize <= 100000 && message !== "";

  const handleImageChange = (inputId) => {
    encodeImageAsURL(inputId, setConverted);
  };

  const handleSubmit = () => {
    const postObject = {
      contentBody: message,
      isBookmarked: false,
      likes: [{ likedUserName: "" }],
      userEmail: user?.email,
      authorEmail: user?.email,
      authorName: authorName,
      contentImage: converted,
    };

    axios
      .post(`${getHost()}/api/user-posts`, postObject, {
        headers: {
          Authorization: `Bearer ${user.accessToken}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then(() => {
        setMessage("");
        setConverted("");
        setShow(false);
        refetch();
      })
      .catch((err) => console.log(err.message));
  };

  const handleReset = () => {
    setMessage("");
    setConverted("");
  };

  return {
    message,
    setMessage,
    show,
    setShow,
    converted,
    fileSize,
    characterLimit,
    canSubmit,
    handleImageChange,
    handleSubmit,
    handleReset,
  };
};

export default useWritePost;
